import React from 'react'
import { useTranslation } from 'react-i18next'
import { useUnits } from '../../../contexts/UnitsContext'
import { cn } from '../../../lib/utils'

const SYSTEMS = [
  { key: 'metric', label: 'kg' },
  { key: 'imperial', label: 'lb' },
]

export function UnitsToggle() {
  const { t } = useTranslation()
  const { unitSystem, setUnitSystem } = useUnits()

  return (
    <div
      className="inline-flex items-center bg-muted rounded-lg p-0.5 text-[11px] font-mono font-medium"
      role="group"
      aria-label={t('phoenixTracker.units.metric') + ' / ' + t('phoenixTracker.units.imperial')}
    >
      {SYSTEMS.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          onClick={() => setUnitSystem(key)}
          className={cn(
            'px-2.5 py-1.5 rounded-md transition-colors',
            unitSystem === key
              ? 'bg-app-primary-500 text-white shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          )}
          title={t('phoenixTracker.units.switchTo', {
            system: t(`phoenixTracker.units.${key}`),
          })}
        >
          {label}
        </button>
      ))}
    </div>
  )
}
